module.exports = __webpack_public_path__ + "static/media/increase-arrow.8e36483a.svg";